import { InputRule } from "@tiptap/core";
import { Selection } from "@tiptap/pm/state";
import { ReactNodeViewRenderer } from "@tiptap/react";
import CodeBlockShiki from "tiptap-extension-code-block-shiki";
import { useUIStore } from "../store/ui";
import { CodeBlockView } from "./CodeBlockView";

const backtickInputRegex = /^```([a-z]+)?[\s\n]$/;
const tildeInputRegex = /^~~~([a-z]+)?[\s\n]$/;

export const CodeBlockExtension = CodeBlockShiki.extend({
  addNodeView() {
    return ReactNodeViewRenderer(CodeBlockView);
  },

  addInputRules() {
    const type = this.type;
    return [backtickInputRegex, tildeInputRegex].map(
      (regex) =>
        new InputRule({
          find: regex,
          handler: ({ state, range, match }) => {
            const language = match[1] || useUIStore.getState().lastCodeLanguage;
            state.tr
              .delete(range.from, range.to)
              .setBlockType(range.from, range.from, type, { language });
          },
        }),
    );
  },

  addKeyboardShortcuts() {
    return {
      ...this.parent?.(),
      Tab: ({ editor }) => {
        if (!editor.isActive("codeBlock")) return false;
        editor.view.dispatch(editor.view.state.tr.insertText("\t"));
        return true;
      },
      ArrowUp: ({ editor }) => {
        if (!editor.isActive("codeBlock")) return false;
        const { state } = editor;
        const { $from } = state.selection;
        // Only escape on the first line (no newline between block start and cursor)
        if (state.doc.textBetween($from.start(), $from.pos).includes("\n"))
          return false;
        const before = $from.before($from.depth);
        if (before <= 0) return false;
        editor.view.dispatch(
          state.tr.setSelection(Selection.near(state.doc.resolve(before), -1)),
        );
        return true;
      },
      ArrowDown: ({ editor }) => {
        if (!editor.isActive("codeBlock")) return false;
        const { state } = editor;
        const { $from } = state.selection;
        // Only escape on the last line (no newline between cursor and block end)
        if (state.doc.textBetween($from.pos, $from.end()).includes("\n"))
          return false;
        const after = $from.after($from.depth);
        if (after >= state.doc.content.size) return false;
        editor.view.dispatch(
          state.tr.setSelection(Selection.near(state.doc.resolve(after), 1)),
        );
        return true;
      },
    };
  },
}).configure({
  defaultTheme: "rose-pine-dawn",
  themes: {
    light: "rose-pine-dawn",
    dark: "rose-pine-moon",
  },
});
